import { fetcher } from '../utils'

export default async (connectionKey: string, flowId: string): Promise<string> =>
  fetcher(`/api/chats/${connectionKey}/flows/preview/${flowId}`, 'GET', undefined)
